export default "__VITE_ASSET__c8b750d5__"